import { render, staticRenderFns } from "./Reporte_Stock_Bodega.vue?vue&type=template&id=05220d8c&"
import script from "./Reporte_Stock_Bodega.vue?vue&type=script&lang=js&"
export * from "./Reporte_Stock_Bodega.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports